/*global diy */

var $ = require('jquery');
var UUID = require('diy/util/UUID');
var websiteData = require('diy/util/websiteData');
var page = require('diy/page/page');

var
    SESSION_ID_COOKIE_NAME = 'DIY_SB',
    Helper;

if (top !== window && typeof process === 'undefined') {
    throw new Error("Helper not usable in an iframe via require. Use 'diy.editor.util.helper' instead");
}

/**
 * @class diy.util.Helper
 * @template diy.util.Helper
 * @lends {diy.util.Helper.prototype}
 * @constructor
 */
Helper = Klazz.extend({
    /**
     * Detects if the user has just logged in
     *
     * @returns {boolean}
     */
    isJustLoggedIn: function () {
        return (diy.editor.isJustLoggedIn && diy.editor.isJustLoggedIn === 1);
    },
    /**
     * Returns the current pageId opened in user's browser
     *
     * @returns {Number}
     */
    getCurrentPageId: function () {
        return parseInt(page.getCurrentPageId(), 10);
    },

    /**
     * Returns the current websiteId
     * @returns {Number}
     */
    getWebsiteId: function () {
        return parseInt(websiteData.getId(), 10);
    },
    /**
     * Returns the current session name
     *
     * @returns {String}
     */
    getSessionName: function () {
        return $.cookie(SESSION_ID_COOKIE_NAME);
    },
    /**
     * Zero-padding function
     *
     * @param n number to be padded
     * @param {Number} width length of the resulting string
     * @param {String} z characters to pad with, default '0'
     * @returns {string}
     */
    formatIndex: function (n, width, z) {
        z = z || '0';
        width = width || 7;

        n = n + '';
        return n.length >= width ? n : new Array(width - n.length + 1).join(z) + n;
    },

    /**
     * Generates an unique string UUID.random format
     *
     * @returns {String}
     */
    generateKey: function () {
        return UUID.generate();
    },

    /**
     * Capitalize the given string
     *
     * @param string
     * @returns {string}
     */
    capitalize: function (string) {
        string += '';
        return string.charAt(0).toUpperCase() + string.slice(1);
    },

    /**
     * Uses jQuery.loadingBox to create interface blockers
     *  above content and ui elements
     * Creates div.diye.diy-util-helper-overlay in body with a dynamic top zIndex and returns an id to be used as
     *  a jQuery filter
     *
     * @param {Object} addOptions - will extend default options that will be passed to jQuery.loadingBox
     * @param {Boolean=} clearAll
     * @param {Boolean=} createBox
     * @param {String=} overlayClassName
     * @returns {string}
     */
    overlay: function (addOptions, clearAll, createBox, overlayClassName) {
        var
            defaultClassName = 'diy-util-helper-overlay',
            zIndex = diy.editor.getNewTopZIndex(),
            options = {
                useOverlay: true,
                zIndex: zIndex
            },

            clearBoxes = ((clearAll === false) ? clearAll : true),
            createNew = ((createBox === false) ? createBox : true),
            className = (typeof overlayClassName === 'undefined')? defaultClassName: overlayClassName.toString(),
            boxId = className.replace(/\./g, '-') + '-' + UUID.generate(),
            boxHtml,
            box;

        if (clearBoxes) {
            $('body>div.diye.' + className).remove();
        }

        if (createNew === true) {
            boxHtml = [
                '<div ', 'class="diye ',  className, '"', ' id="', boxId, '"',
                ' style="z-index:', zIndex, ';', '"></div>'
                ].join("");

            $('body').append(boxHtml);

            $.extend(true, options, addOptions);
            box = $('body #' + boxId);
            box.loadingBox(options).show();

            return boxId;
        }
    },
    /**
     * Performs a browser reload / redirect to the given url
     *  using fade effect
     *
     * @param {?String} url
     * @param {?String} message
     * @param {Number=} delay
     */
    browserReload: function (url, message, delay) {
        var options = {};

        delay = delay || 100;

        if (message) {
            options = {loadingText: message.toString()};
        }

        this.overlay(options, true, true);

        $('body').find('.loadingBox-overlay:visible').animate({
            opacity: 1
        }, 2000);
        /*
         * safari for mac seems to freeze the UI when starting a form
         * request that changes the current page.
         * for this reason, we wait a bit for the loadingBox to display
         * and only after that we reload the page
         */
        if (delay >= 0) {
            Q.delay(delay).done(
                function () {
                    if (url === null) {
                        window.location.reload();
                    } else {
                        window.location.href = url;
                    }
                }
            );
        }
    }
});

module.exports = new Helper();



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/util/helper.js
 ** module id = 717
 ** module chunks = 0
 **/